export default {
  headerColor: '',
};
